export default "__VITE_ASSET__fU0_5vpL__"